import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { StateDto, CountryDto } from '@cradua/data';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-state',
  templateUrl: './state.component.html',
  styleUrls: ['./state.component.scss']
})
export class StateComponent implements OnChanges {

  @Input() states: StateDto[];
  @Input() countries: CountryDto[];
  stateForm: FormGroup;
  stateFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<StateDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  filteredDelete: Array<any> = [];
  filteredState: Array<any> = [];
  status: boolean; 
  selectedStateId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnChanges() {
    this.createStateForm();
  }

  createStateForm() {
    this.stateFormArray = this.fb.group({ States: this.fb.array([]) });
    this.stateForm = this.fb.group({
      StateName: ['', Validators.required],
        CountryId: this.selectedStateId,
        Abbreviation:[''],
        id: null
    });
  }


  // method to display companies
  setState() {
    const control = this.stateFormArray.controls.States as FormArray;
    this.filteredState.forEach((e) => {
      control.push(
        this.fb.group({
          StateName: e.StateName,
          CountryId: e.CountryId,
          Abbreviation: e.Abbreviation,
          id: e.id,
        })
      );
    });
  }

   // method to add Company
   addState(state: StateDto) {
    console.log('state');
    const control = this.stateFormArray.controls.States as FormArray;
    control.insert(
      0,
      this.fb.group({
        StateName: state.StateName,
        CountryId: this.selectedStateId,
        Abbreviation: state.Abbreviation,

      })
    );
  }


  // method to reset form array after selection
  clearFormArray = (formArray: FormArray) => {
    const control = this.stateFormArray.controls.States as FormArray;
    while (formArray.length !== 0) {
      control.removeAt(0);
    }
  };

  // method to filter country
  selectCountry(event: string) {
    this.filteredState = this.states.filter((s) => s.CountryId === event);
    this.selectedStateId = event;
    const control = this.stateFormArray.controls.States as FormArray;

    if (this.filteredState.length > 0) {
      this.status = true;
      this.clearFormArray(control);
      this.setState();
    } else {
      this.status = true;
      this.clearFormArray(control);
    }
  }

  print(event: any) {
    window.print();
  }
  // method to delete company from arrary list
  deleteState(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    }).then((result) => {
      if (result.value) {
        const control = this.stateFormArray.controls.States as FormArray;
        control.removeAt(index);
        for (let i = 0; i < this.states.length; i++) {
          if (i === index) {
            if (value.id !== null) {
              this.filteredDelete.push(this.states[i].id);
            }
          }
        }
        Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }


  addNew(formValue: StateDto) {
    if(this.stateForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.stateFormArray.get('States')['controls'][this.selectedIndex].patchValue({StateName: formValue.StateName, Abbreviation: formValue.Abbreviation});
    } else {
      this.addState(formValue);
    }
    this.selectedIndex = null;
    this.stateForm.reset()
  }

  onEdit(index, value: StateDto) {
    this.selectedIndex = index;
    this.stateForm.patchValue({StateName: value.StateName, Abbreviation: value.Abbreviation});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.stateForm.reset();
  }


  onSubmit(formValue: any) {
    formValue.type = 'state';
    this.changeEmit.emit(formValue);
    if (this.filteredDelete.length > 0) {
      this.filteredDelete.unshift('state');
      this.deleteEvent.emit(this.filteredDelete);
    }
  }

}
